import callUs from '@/public/images/GF-0074-CALL US.svg';
import chatUs from '@/public/images/GF-0074-CHAT WITH US.svg';
import email from '@/public/images/GF-0074-EMAIL US.svg';
import scheduleCall from '@/public/images/GF-0074-SCHEDULE A CALL.svg';

export const ContentTypes = {
  gfLayoutHelpCenter: 'gfLayoutHelpCenter',
  gfHeroBannerType: 'componentHeroBannerHelpCenter',
  gfContactUsType: 'componentContactUsModuleHelpCenter',
  gfSubHeader: 'subHeaderHelpCenter',
  gfContentTabs: 'contentTabContainerHelpCenter',
  gfNoResultsFoundType: 'componentNoResultsFoundHelpCenter',
  gfRatings: 'componentRatingsHelpCenter',
  gfCardsContainer: 'cardsContainerHelpCenter',
};

export const Variations = {
  heroBannerVariation1: 'heroV1: Hero Banner For Landing Page',
  heroBannerVariation2: 'heroV2: Hero Banner For Search Page',
};

export const InternalNames = {
  manageCookies: 'Manage cookies',
};

export const SEARCH_SUGGESTIONS_API_DEBOUNCE_TIME = 500;

export const DevFiberUrl = 'https://fg.dev.gfiber.com/support';
export const DevBaseUrl = 'https://fg.dev.gfiber.com';
export const EmailSupportUrl =
  'https://support.google.com/fiber/contact/fiber_general_open';

export const cards_en = [
  {iconTitle: 'Email us', iconSrc: email.src},
  {iconTitle: 'Chat us', iconSrc: chatUs.src},
  {iconTitle: 'Call us', iconSrc: callUs.src},
  {iconTitle: 'Schedule a call', iconSrc: scheduleCall.src},
];
export const cards_es = [
  {iconTitle: 'Envíanos un correo electrónico', iconSrc: email.src},
  {iconTitle: 'Chatea con nosotros', iconSrc: chatUs.src},
  {iconTitle: 'Llámanos', iconSrc: callUs.src},
  {iconTitle: 'Programe una llamada', iconSrc: scheduleCall.src},
];

export const successText = 'SUCCESS';

export const apiError = {
  errorMessage1:
    'Oops! Something went wrong. While we’re working on fixing this, try refreshing the page or',
  errorMessage2: 'if you continue to have issues.',
  supportLinkURL: 'https://fiber.google.com/support/',
  supportLinkText: 'contacting our support team ',
};

export const supportBasePath = '/support';

export const subNavItems_en = [
  {id: '1030', title: 'Quick answers'},
  {id: '1031', title: 'Troubleshoot issues'},
  {id: '1032', title: 'Get Fiber'},
  {id: '1033', title: 'Fiber user guide'},
  {id: '1034', title: 'Manage your account'},
  {id: '1035', title: 'Commercial and multi-family buildings'},
];
export const subNavItems_es = [
  {id: '1030', title: 'Respuestas rápidas'},
  {id: '1031', title: 'Solucionar problemas'},
  {id: '1032', title: 'Contrata Fiber'},
  {id: '1033', title: 'Guía del usuario de Fiber'},
  {id: '1034', title: 'Administrar tu cuenta'},
  {id: '1035', title: 'Edificios comerciales y residencias multifamiliares'},
];

export const entryModalDefaultRedirectUrl = '/webpass/support/';

export const webpassSwitcher_en = {
  gfiberWebpassText: 'Looking for the GFiber Webpass Help Center?',
  linkSwitcherText: 'Find it here',
  redirectURL: '/webpass/support',
};
export const webpassSwitcher_es = {
  gfiberWebpassText: 'Spanish Looking for the GFiber Webpass Help Center? ',
  linkSwitcherText: 'Spanish Find it here',
  redirectURL: '/webpass/support',
};

export const webpassCustomerText = 'Google Fiber Webpass customer';
export const googleFiberCustomberText = 'Google Fiber customer';
export const cocoId = 'fiber_coco';
